"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationJsonUpdater = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const ConfigurationJsonUtils_1 = require("./ConfigurationJsonUtils");
const echain_product_models_1 = require("@igus/echain-product-models");
class ConfigurationJsonUpdater {
    /**
     * Updates multiple `ConfigurationJson` by an `ArticlesDict` dict.
     * The new article data is patched into the existing one. In case of an unknown article, it is skipped.
     */
    static updateArticleJsonsInMultipleConfigs(sourceArticlesJsons, ...targetConfigurationJsons) {
        targetConfigurationJsons.forEach((targetConfigurationJson) => {
            this.updateArticleJsonsInConfig(sourceArticlesJsons, targetConfigurationJson);
        });
    }
    static updateArticleJsonsInConfig(sourceArticlesJsons, targetConfigurationJson) {
        echain_shared_articles_1.ArticleJsonUtils.assignJsons(targetConfigurationJson.AEs, sourceArticlesJsons.ae);
        echain_shared_articles_1.ArticleJsonUtils.assignJson(targetConfigurationJson.Espool, sourceArticlesJsons.espool);
        echain_shared_articles_1.ArticleJsonUtils.assignJson(targetConfigurationJson.Kette, sourceArticlesJsons.kette);
        echain_shared_articles_1.ArticleJsonUtils.assignJsons(targetConfigurationJson.Fuehrungsrinnen, sourceArticlesJsons.fuehrungsrinne);
        echain_shared_articles_1.ArticleJsonUtils.assignJsons(targetConfigurationJson.IAs, sourceArticlesJsons.ia);
        echain_shared_articles_1.ArticleJsonUtils.assignJsons(targetConfigurationJson.Konfektionierungen, sourceArticlesJsons.konfektionierung);
        echain_shared_articles_1.ArticleJsonUtils.assignJsons(targetConfigurationJson.Leitungen, sourceArticlesJsons.leitung);
        echain_shared_articles_1.ArticleJsonUtils.assignJsons(targetConfigurationJson.MontageSets, sourceArticlesJsons.montageSet);
        echain_shared_articles_1.ArticleJsonUtils.assignJsons(targetConfigurationJson.MontBes, sourceArticlesJsons.montBes);
        echain_shared_articles_1.ArticleJsonUtils.assignJsons(targetConfigurationJson.Verpackungen, sourceArticlesJsons.verpackung);
        echain_shared_articles_1.ArticleJsonUtils.assignJsons(targetConfigurationJson.Zugentlastungen, sourceArticlesJsons.zugentlastung);
        echain_shared_articles_1.ArticleJsonUtils.assignJsons(targetConfigurationJson.Zubehoer, sourceArticlesJsons.zubehoer);
    }
    /**
     * Updates a `ConfigurationJson` by an `ArticlesDict` dict.
     * The new article data is patched into the existing one. In case of an unknown article, it is removed.
     */
    static updateOrRemoveArticles({ staticArticleDataDict, configurationJson, }) {
        const updatedConfiguration = ConfigurationJsonUtils_1.ConfigurationJsonUtils.clearArticles(configurationJson);
        const removedArticles = echain_shared_articles_1.ArticlesDictUtils.create();
        // populate `updatedConfiguration` and `removedArticles`
        echain_product_models_1.allArticleTypes.forEach((articleType) => {
            ConfigurationJsonUtils_1.ConfigurationJsonUtils.getArticlesByType(configurationJson, articleType).forEach((article) => {
                // invented article
                if (article.ArtNrExists === false) {
                    // keep it
                    ConfigurationJsonUtils_1.ConfigurationJsonUtils.addArticle(updatedConfiguration, article);
                }
                // existing article
                else {
                    const staticArticleData = echain_shared_articles_1.ArticlesDictUtils.find(staticArticleDataDict, article);
                    if (staticArticleData) {
                        // update
                        ConfigurationJsonUtils_1.ConfigurationJsonUtils.addArticle(updatedConfiguration, Object.assign(Object.assign({}, article), staticArticleData));
                    }
                    else {
                        // remove
                        echain_shared_articles_1.ArticlesDictUtils.add(removedArticles, article);
                    }
                }
            });
        });
        return { updatedConfiguration, removedArticles };
    }
    /**
     * Retrieves a dict of all removed Articles.
     */
    static getRemovedArticles({ originalConfigurationJson, updatedConfigurationJson, }) {
        const removedArticles = echain_shared_articles_1.ArticlesDictUtils.create();
        echain_product_models_1.allArticleTypes.forEach((articleType) => {
            const originalArticles = ConfigurationJsonUtils_1.ConfigurationJsonUtils.getArticlesByType(originalConfigurationJson, articleType);
            const updatedArticles = ConfigurationJsonUtils_1.ConfigurationJsonUtils.getArticlesByType(updatedConfigurationJson, articleType);
            originalArticles.forEach((oA) => {
                if (!updatedArticles.some((uA) => echain_shared_articles_1.ArticleJsonUtils.areSameArticles(oA, uA))) {
                    echain_shared_articles_1.ArticlesDictUtils.addByType(removedArticles, oA, articleType);
                }
            });
        });
        return removedArticles;
    }
}
exports.ConfigurationJsonUpdater = ConfigurationJsonUpdater;
ConfigurationJsonUpdater.className = 'ConfigurationJsonUpdater';
//# sourceMappingURL=ConfigurationJsonUpdater.js.map